<script setup>
import { ref, onMounted } from "vue";
import { appBarStore } from "@/stores/appBar";
import router from "@/router";

function goTo(link) {
  router.push({ name: link });
}

onMounted(() => {
  appBarStore().$reset();
  appBarStore().$patch({
    appRunning: "ELA Admin",
    type: "None",
    items: [],
    selected: "",
  });
});

const randomKey = ref("");
function updateRandom() {
  randomKey.value = Math.random().toString(36).substring(2, 15);
}

const items = ref([
  { title: "Permissions", icon: "mdi-account-key", link: "AdminPermissions" },
  { title: "Roles", icon: "mdi-account-key", link: "AdminRoles" },
  { title: "Customers", icon: "mdi-account-key", link: "AdminCustomers" },
  { title: "Groups", icon: "mdi-account-key", link: "AdminGroups" },
  { title: "Users", icon: "mdi-account-key", link: "AdminUsers" },
  {
    title: "Customer Groups",
    icon: "mdi-account-key",
    link: "AdminCustomerGroups",
  },
  { title: "Inspector", icon: "mdi-magnify", link: "AdminInspector" },
]);
</script>

<template>
  <v-navigation-drawer permanent width="190" theme="jigsawDark">
    <v-list density="compact">
      <template v-for="item in items" :key="item">
        <v-list-item
          link
          :to="{ name: item.link }"
          color="#e7541e"
          @click="updateRandom"
        >
          <v-list-item-title @click="goTo(item.link)"
            ><v-icon>{{ item.icon }}</v-icon>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
  <v-main>
    <v-container fluid>
      <router-view :key="randomKey" />
    </v-container>
  </v-main>
</template>
